import { useState } from "react"
import { Tooltip } from "@mui/material"
import { faBasketShoppingPlus } from "@fortawesome/pro-regular-svg-icons"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { ProductWishDialog } from "./ProductWishDialog"
import { ActionButton } from "../header/ActionButton"

type ProductWishProps = Readonly<{}>

export function ProductWish({}: ProductWishProps) {
    const [openDialog, setOpenDialog] = useState(false)

    const handleAddClick = () => {
        setOpenDialog(true)
    }

    return (
        <>
            <LocalizedStrict id="create-order-wish" attrs={{ title: true }}>
                <Tooltip title="Wish">
                    <div>
                        <ActionButton icon={faBasketShoppingPlus} handleButtonClick={handleAddClick} />
                    </div>
                </Tooltip>
            </LocalizedStrict>
            {openDialog && <ProductWishDialog open={openDialog} onClose={() => setOpenDialog(false)} />}
        </>
    )
}
